export * from './icon';
// TODO: faze out default import gradually and then remove.
export { Icon as default } from './icon';
